import { GOOSE_GAME_POINTS_NAME } from "src/shared/constants/gooseGames";
import { QuestType } from "src/views/goose-games/types";

const QUEST_DROPDOWN = [
  // {
  //   label: "Scanned",
  //   value: QuestType.Scanned,
  //   icon: "qrcode",
  //   color: "#9344ED",
  //   backgroundColor: "#EADFF9",
  // },
  {
    label: "Question",
    value: QuestType.Question,
    icon: "chat",
    color: "#F99828",
    backgroundColor: "#FFFBEB",
  },
  {
    label: "Organizer",
    value: QuestType.OrganizerApproved,
    icon: "gear",
    color: "#1AB3B0",
    backgroundColor: "#DFF9F4",
  },
  {
    label: "Badge",
    value: QuestType.Badge,
    icon: "badge",
    color: "#3E55DA",
    backgroundColor: "#E6EAFF",
  },
  {
    label: "Networking",
    value: QuestType.Networking,
    icon: "network",
    color: "#DA3EC3",
    backgroundColor: "#FAE4FF",
  },
];

export const MODAL_FIELDS = {
  QUEST: {
    create: {
      title: "Create new quest",
      name: ["Quest Name", "Question"],
      name_placeholder: "Give it a catchy title...",
      type: "Quest Type",
      type_options: QUEST_DROPDOWN,
      num_input: "Reward (# points)",
      num_input_placeholder: "i.e. 25",
      success: "Successfully created new quest!",
      error: "Unable to create new quest.",
    },
    edit: {
      title: "Edit quest",
      name: ["Quest Name", "Question"],
      name_placeholder: "Give it a catchy title...",
      type: "Quest Type",
      type_options: QUEST_DROPDOWN,
      num_input: "Reward (# points)",
      num_input_placeholder: "i.e. 25",
      success: "Changes saved.",
      error: "Changes not saved.",
    },
    delete: {
      title: "Confirm Quest Deletion",
      message: "Are you sure you want to delete this quest?",
      success: "Successfully deleted quest!",
      error: "Unable to delete quest.",
    },
  },
  PRIZE: {
    create: {
      title: "Create new prize",
      name: "Prize Name",
      name_placeholder: "Name",
      type: "Availability",
      type_options: [
        {
          label: "Available",
          value: "AVAILABLE",
          color: "#D1FAE5",
          backgroundColor: "#54C152",
        },
        {
          label: "SOLD OUT",
          value: "SOLD_OUT",
          color: "#D95858",
          backgroundColor: "#F7DDDD",
        },
      ],
      count_input: "Remaining inventory",
      count_input_placeholder: "i.e. 100",
      num_input: `Cost (# ${GOOSE_GAME_POINTS_NAME})`,
      num_input_placeholder: "i.e. 25",
      success: "Successfully created new prize!",
      error: "Unable to create new prize.",
    },
    edit: {
      title: "Edit prize",
      name: "Prize Name",
      name_placeholder: "Name",
      type: "Availability",
      type_options: [
        {
          label: "Available",
          value: "AVAILABLE",
          color: "#D1FAE5",
          backgroundColor: "#54C152",
        },
        {
          label: "SOLD OUT",
          value: "SOLD_OUT",
          color: "#D95858",
          backgroundColor: "#F7DDDD",
        },
      ],
      count_input: "Remaining inventory",
      count_input_placeholder: "i.e. 100",
      num_input: `Cost (# ${GOOSE_GAME_POINTS_NAME})`,
      num_input_placeholder: "i.e. 25",
      success: "Changes saved.",
      error: "Changes not saved.",
    },
    delete: {
      title: "Confirm Prize Deletion",
      message: "Are you sure you want to delete this prize?",
      success: "Successfully deleted prize!",
      error: "Unable to delete prize.",
    },
  },
};
